import { createListenerMiddleware } from "@reduxjs/toolkit";
import { authApi } from "../services/auth";
import { telegramApi } from "../services/telegram";

export const listenerAuthMiddleware = createListenerMiddleware();

listenerAuthMiddleware.startListening({
  matcher: authApi.endpoints.login.matchFulfilled,
  effect: (action, listenerApi) => {
    const { access_token, refresh_token } = action.payload;

    if (access_token) localStorage.setItem("access_token", access_token);
    if (refresh_token) localStorage.setItem("refresh_token", refresh_token);
  },
});

// Store tokens when telegram verify succeeds
listenerAuthMiddleware.startListening({
  matcher: telegramApi.endpoints.verify.matchFulfilled,
  effect: (action, listenerApi) => {
    const payload = action.payload || {};
    const access_token = payload.access_token || payload.token || null;
    const refresh_token = payload.refresh_token || null;
    if (access_token) {
      localStorage.setItem("access_token", access_token);
    }
    if (refresh_token) {
      localStorage.setItem("refresh_token", refresh_token);
    }
    try {
      if (localStorage.getItem("token")) localStorage.removeItem("token");
    } catch (e) {
      console.error("listenerAuthMiddleware: failed to remove legacy token", e);
    }
  },
});

listenerAuthMiddleware.startListening({
  matcher: authApi.endpoints.logout.matchFulfilled,
  effect: (action, listenerApi) => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  },
});
